import { render, staticRenderFns } from "./AdminEditor.vue?vue&type=template&id=773243ca&"
import script from "./AdminEditor.vue?vue&type=script&lang=js&"
export * from "./AdminEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports